import { useAuth } from "../../auth/useAuth";

const AuthDebugPanelInner = () => {
  const { user, isAuthenticated, isLoading } = useAuth();

  return (
    <aside className="auth-debug-panel" aria-label="Auth debug (development only)">
      <p className="eyebrow">Auth debug</p>
      <ul>
        <li>loading: {String(isLoading)}</li>
        <li>authenticated: {String(isAuthenticated)}</li>
        <li>email: {user?.email || "—"}</li>
        <li>roles: {user?.roles?.map((r) => r.roleCode).join(", ") || "—"}</li>
        <li>permissions: {user?.permissions?.length ?? 0}</li>
      </ul>
    </aside>
  );
};

const AuthDebugPanel = () => {
  const enabled =
    process.env.NODE_ENV === "development" &&
    process.env.REACT_APP_AUTH_DEBUG === "true";

  if (!enabled) {
    return null;
  }

  return <AuthDebugPanelInner />;
};

export default AuthDebugPanel;
